import { createVNode, render, ref, type VNode, type VNodeProps } from 'vue';
import { invoke } from '@yoda/bridge';
import Loading from './LoadingPage.vue';

let loadingInstance: VNode | null = null;
let el: HTMLElement | null = null;

export const isShowing = ref(false);

export function showLoading(props?: Record<string, unknown> & VNodeProps) {
    if (loadingInstance !== null) {
        return;
    }
    loadingInstance = createVNode(Loading, props);
    el = document.createElement('div');
    render(loadingInstance, el);
    document.body.appendChild(el);
    isShowing.value = true;
}

export function hideLoading() {
    if (loadingInstance === null) {
        return;
    }
    if (el) {
        document.body.removeChild(el);
        render(null, el);
    }
    el = null;
    loadingInstance = null;
    isShowing.value = false;
    invoke('ui.hideLoadingPage');
}
